import { IPartner } from 'clickNgo/entities/partner/models'

export const sortPartnerListByHierarchy = (partners: IPartner[]): IPartner[] => {
  const sortedPartners = partners.sort((a, b) => {
    if (a.partnerId === b.topPartnerId) {
      return -1
    }

    if (b.partnerId === a.topPartnerId) {
      return 1
    }

    return 0
  })

  return sortedPartners
}
